import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import { configureAmplify } from '@auth/configureAmplify';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

configureAmplify();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Disabling DataDog RUM worker. It's configured in DataDog but we don't want it running yet for this app
// dataDogRUMWorker();
